// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__qFTVn","icon":"holding-image_icon__zXB2P"};